import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Text from '../../../components/Text/Text';
import Input from '../../../components/Input/Input';
import Button from '../../../components/Button/Button';
import { clearForgotPassword } from '../../../thunks/auth/forgotPassword';
import alertType from '../../../common/alertType';
import Alert from '../../../components/Alert/Alert';
import useQueryParams from '../../../hooks/useQueryParams';
import resetPassword from '../../../thunks/auth/resetPassword';

const ResetPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [{ token }] = useQueryParams();
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const {
    resetPassword: {
      data: resetResult,
      loading,
      error
    },
  } = useSelector((state) => ({
    resetPassword: state.resetPassword
  }), shallowEqual);

  useEffect(() => {
    if (resetResult?.status === 'ok') {
      setTimeout(() => {
        navigate('/');
      }, 2000);
    }
  }, [resetResult]);

  useEffect(() => {
    dispatch(clearForgotPassword());
  }, []);

  const onSubmit = () => dispatch(resetPassword({
    token,
    password
  }));

  return (
    <div className="bg-background-light min-h-screen flex justify-center items-center">
      <div className="w-full max-w-[450px] text-center p-[40px] rounded-[10px] shadowDefault">
        <Text
          text="Create new Password"
          bold
          styleContainer="justify-center"
          textStyle="text-[20px]"
        />
        <div className="mb-[65px]" />
        <div>
          <Input
            type="password"
            name="password"
            value={password}
            placeholder="new password"
            onChange={({ target: { value } }) => setPassword(value)}
          />
          <Input
            type="password"
            name="passwordConfirm"
            value={passwordConfirm}
            placeholder="new password confirm"
            onChange={({ target: { value } }) => setPasswordConfirm(value)}
          />
          <div className="flex flex-row justify-center">
            <Button
              text="Update password"
              disabled={!token || password !== passwordConfirm || password < 4}
              onClick={onSubmit}
            />
          </div>
          <br />
          {(resetResult || error) && !loading && (
            <Alert
              text={resetResult?.message || error}
              type={resetResult?.status === 'ok' ? alertType.info : alertType.warning}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
